import { Tag } from 'antd';
import dayjs from 'dayjs';

export const ALL_APPLICANT_STATUS_FIELDS_FOR_DISPLAY = [
    { key: 'registrationStatus', label: 'Step 1: Student Registration' },
    { key: 'preferredExamAndInterviewApplicationStatus', label: 'Step 2: Exam & Interview Schedule' },
    { key: 'admissionRequirementsStatus', label: 'Step 3: Admission Requirements' },
    { key: 'admissionExamDetailsStatus', label: 'Step 4: Assign Exam Schedule (Admin Action Required)' },
    { key: 'approvedExamFeeStatus', label: 'Step 5: Exam Fee Payment' },
    { key: 'approvedExamInterviewResult', label: 'Step 6: Exam & Interview Result (Admin Action Required)' },
    { key: 'examInterviewResultStatus', label: 'Final Exam & Interview Standing' },
    { key: 'reservationFeePaymentStepStatus', label: 'Step 7: Reservation Fee Payment' },
    { key: 'admissionApprovalAdminStatus', label: 'Step 8: Admission Approval (Admin Action Required)' },
    { key: 'enrollmentRequirementsStatus', label: 'Step 9: Enrollment Requirements' },
    { key: 'voucherApplicationStatus', label: 'Step 10: Voucher Application' },
    { key: 'enrollmentApprovalAdminStatus', label: 'Step 11: Enrollment Approval (Admin Action Required)' },
    { key: 'officialEnrolled', label: 'Officially Enrolled' },
    { key: 'status', label: 'Overall Account Status' },
];

export const getStatusLabel = (statusKey) => {
    if (!statusKey) return 'N/A';
    if (statusKey === 'approvedExamInterviewResult_custom') return 'Review Exam/Interview Result';
    let label = statusKey.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
    label = label.replace(/ID/g, "ID");
    return label.charAt(0).toUpperCase() + label.slice(1).trim();
};

export const STATUS_COLORS = {
    'complete': 'green',
    'completed': 'green',
    'paid': 'green',
    'passed': 'green',
    'approved': 'green',
    'verified': 'green',
    'active': 'green',
    'submitted': 'blue',
    'pending verification': 'blue',
    'scheduled': 'blue',
    'incomplete': 'orange',
    'required': 'orange',
    'pending': 'orange',
    'on-going': 'orange',
    'rejected': 'red',
    'inactive': 'red',
    'dropped': 'red',
    'on-waiting-list': 'geekblue',
    'waived': 'geekblue',
    'withdrawn': 'geekblue',
    'default': 'default'
};

export const renderApplicantStatus = (statusKey, statusValue) => {
    const lowerStatusValue = String(statusValue || '').toLowerCase();
    let displayValue = 'N/A';
    if (statusValue !== undefined && statusValue !== null) {
        displayValue = typeof statusValue === 'boolean' ? (statusValue ? 'Yes' : 'No') : String(statusValue);
    }

    let color = STATUS_COLORS[lowerStatusValue] || STATUS_COLORS['default'];

    return <Tag color={color}>{displayValue}</Tag>;
};

export const formatDate = (dateString, format = 'YYYY-MM-DD HH:mm') => {
    if (!dateString) return 'N/A';
    const date = dayjs(dateString);
    return date.isValid() ? date.format(format) : 'N/A';
};